import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { PROPERTY_SECTION_KEYS } from "../property.constants";

import { rows } from "./projections-variables-rows";

export class ProjectionsVariables extends Component {
  render() {
    const { data, propertyId, isSold, history, propertyProjections, enableEditButton, ...other } = this.props;

    const projectionData = propertyProjections && propertyProjections.property && propertyProjections.property ? propertyProjections.property : [];

    const sectionData = { ...data, ...projectionData };

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Projections",
            key: PROPERTY_SECTION_KEYS.PROJECTION_VARIABLES,
            isExpandable: true,
            isTitleGroup: false,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/properties/${data.id}/edit/${PROPERTY_SECTION_KEYS.PROJECTION_VARIABLES}`),
            sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={sectionData} />
            ]
          }
        ]}
      />
    );
  }
}
